<div class="view-toolbar" [ngClass]="{'view-with-details': showViewDetails}">
  <ng-container *ngIf="viewTypeLbl?.length">
    <mat-chip class="view-type-badge" color="primary">{{ viewTypeLbl | translate }}</mat-chip>
  </ng-container>

  <div
    class="view-selector-wrapper"
    [ngClass]="{'view-selector-wrapper--editor': refModel.sourceType === 'salesforce'}">
    <div class="select-cn-view-block">
      <mat-form-field
        class="q9-form-field q9-full-width grid-view-input"
        appearance="outline"
        subscriptSizing="dynamic"
        floatLabel="always"
        [title]="selectedViewName"
        [matMenuTriggerFor]="selector">
        <mat-label>{{ 'RUBIC_CUBE.VIEWS_LABEL' | translate }}</mat-label>

        <mat-select
          class="q9-select"
          panelClass="grid-views-select-panel"
          #selectInput
          [value]="selectedViewName"
          [disabled]="isLoading"
          [ngClass]="selectedViewName === selectViewPlaceholder ? 'fw-bold' : ''"
          q9Track="CUSTOM_VIEW.DROPDOWN">
          <mat-option
            class="q9-select-option"
            *ngFor="let view of views"
            [value]="view?.name || view">
            {{ selectedViewName }}
          </mat-option>
        </mat-select>

        <div matSuffix>
          <ng-container *ngIf="isLoading">
            <mat-spinner strokeWidth="1" diameter="20"></mat-spinner>
          </ng-container>
        </div>
      </mat-form-field>

      <ng-container *ngIf="refModel.sourceType === 'salesforce'">
        <div
          class="create-new-view"
          [matTooltip]="'RUBIC_CUBE.GLOBAL_PRIVATE_VIEW_LIMITATION_TOOLTIP' | translate: {GLOBAL_LIMIT: LIMIT_FOR_GLOBAL_CUSTOM_VIEWS, PRIVATE_LIMIT: LIMIT_FOR_PRIVATE_CUSTOM_VIEWS}"
          [matTooltipDisabled]="allowCreateNewView">
          <q9-primary-button
            (click)="createNewViewModal()"
            [disabled]="!allowCreateNewView"
            q9Track="CUSTOM_VIEW.CREATE_NEW_VIEW">
            {{ 'RUBIC_CUBE.CREATE_NEW_VIEW' | translate }}
          </q9-primary-button>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="showViewDetails">
      <div class="custom-view-details">
        <div
          class="filter-info"
          [matMenuTriggerData]="{view: selectedView}"
          [matMenuTriggerFor]="details">
          <span class="filter-info-label">{{ 'RUBIC_CUBE.SHOW_DETAILS' | translate }}</span>
          <mat-icon svgIcon="arrow_down" class="filter-info-icon" />
        </div>
      </div>
    </ng-container>
  </div>
</div>

<mat-menu
  #selector="matMenu"
  class="q9-menu grid-views-menu"
  yPosition="below"
  (closed)="selectInput.close()">
  <ng-container *ngFor="let commonView of views.slice(0, 2)">
    <button mat-menu-item class="q9-option-button" (click)="switchTo(commonView)">
      {{ commonView }}
    </button>
  </ng-container>

  <!--  System views -->
  <ng-container *ngIf="refModel.sourceType === 'salesforce'">
    <mat-divider></mat-divider>
    <button
      mat-menu-item
      class="q9-option-button sub-menu-button"
      [matMenuTriggerFor]="systemViews">
      {{ 'RUBIC_CUBE.CLEAN_UP_VIEWS' | translate }}
    </button>

    <!--  Private views -->
    <mat-divider></mat-divider>
    <div
      [matTooltip]="'RUBIC_CUBE.CREATE_PRIVATE_VIEW_HINT' | translate: {count: LIMIT_FOR_PRIVATE_CUSTOM_VIEWS}"
      [matTooltipDisabled]="(privateCustomViewsList$ | async)?.length > 0">
      <button
        mat-menu-item
        class="q9-option-button sub-menu-button"
        [matMenuTriggerFor]="privateViews"
        [disabled]="!(privateCustomViewsList$ | async)?.length">
        {{ 'RUBIC_CUBE.PRIVATE_VIEWS' | translate }}
      </button>
    </div>
    <mat-divider></mat-divider>
  </ng-container>

  <ng-container *ngFor="let customView of globalCustomViewsList$ | async">
    <button
      class="truncate-text"
      mat-menu-item
      [title]="customView.name"
      [matMenuTriggerFor]="actions"
      [matMenuTriggerData]="{view: customView}"
      [ngClass]="{selected: customView._id === selectedView?._id}">
      {{ customView.name | decodeHtml }}
    </button>
  </ng-container>
</mat-menu>

<mat-menu #actions="matMenu" class="q9-menu grid-view-actions-menu">
  <ng-template matMenuContent let-view="view">
    <div mat-menu-item [matMenuTriggerData]="{view}" [matMenuTriggerFor]="details">
      {{ 'RUBIC_CUBE.SHOW_DETAILS' | translate }}
    </div>
    <button mat-menu-item [disabled]="view._id === selectedView?._id" (click)="switchTo(view)">
      {{ 'RUBIC_CUBE.SWITCH_OPTION_TITLE' | translate }}
    </button>
    <span
      matTooltipHideDelay="500"
      matTooltipPosition="below"
      [matTooltipDisabled]="isEditor || view.private"
      [matTooltip]="'RUBIC_CUBE.NO_PERMISSION_UPDATE_GLOBAL_VIEWS' | translate">
      <button
        mat-menu-item
        [disabled]="!isEditor && !view.private"
        (click)="editMetadata(view._id)">
        {{ 'RUBIC_CUBE.EDIT_METADATA_OPTION_TITLE' | translate }}
      </button>
    </span>
    <span
      matTooltipHideDelay="500"
      matTooltipPosition="below"
      [matTooltipDisabled]="(isEditor || view.private) && view._id !== selectedView?._id"
      [matTooltip]="
        (!isEditor && !view.private
          ? 'RUBIC_CUBE.NO_PERMISSION_UPDATE_GLOBAL_VIEWS'
          : 'RUBIC_CUBE.CANNOT_DELETE_SELECTED_VIEW_MSG'
        ) | translate
      ">
      <button
        mat-menu-item
        [disabled]="(!isEditor && !view.private) || view._id === selectedView?._id"
        (click)="remove(view)">
        {{ 'RUBIC_CUBE.REMOVE_OPTION_TITLE' | translate }}
      </button>
    </span>
  </ng-template>
</mat-menu>

<mat-menu #details="matMenu" (click)="$event.stopPropagation()">
  <ng-template matMenuContent let-view="view">
    <div class="details-section">
      <ng-container *ngIf="view?.description">
        <p class="detail-label">{{ 'RUBIC_CUBE.VIEW_DESCRIPTION_LABEL' | translate }}</p>
        <p [ngClass]="{'expanded': fullText}" class="text-container">{{ view?.description }}</p>
        <ng-container *ngIf="view.description.length > 100">
          <q9-link-button
            (click)="$event.stopPropagation(); $event.preventDefault(); showHideFullDescription($event)">
            {{ fullText ? 'Hide' : 'RUBIC_CUBE.SHOW_FULL' | translate }}
          </q9-link-button>
        </ng-container>
      </ng-container>

      <p class="detail-label">{{ 'RUBIC_CUBE.VIEW_SCOPE' | translate }}</p>
      <div class="values-list">
        <ng-container *ngIf="view.allNodes">
          <q9-tag [color]="'accent'">{{ 'RUBIC_CUBE.ALL_MD_TYPES' | translate }}</q9-tag>
        </ng-container>
        <ng-container *ngIf="!view.allNodes">
          <ng-container *ngFor="let metadataType of view?.metadataList">
            <q9-tag [color]="'accent'">{{ metadataType | translate }}</q9-tag>
          </ng-container>
        </ng-container>
      </div>

      <p class="detail-label">{{ 'RUBIC_CUBE.VIEW_COLUMNS' | translate }}</p>
      <div class="values-list">
        <ng-container *ngFor="let column of view?.columns">
          <ng-container *ngIf="!column.filterOnly">
            <q9-tag [color]="'accent'">
              {{ column.hasSubcolumns ? column.subcolumn.displayValue : column.displayValue }}
            </q9-tag>
          </ng-container>
        </ng-container>
      </div>

      <ng-container *ngIf="view?.filters?.length">
        <p class="detail-label">{{ 'RUBIC_CUBE.VIEW_FILTERS' | translate }}</p>
        <div class="values-list">
          <ng-container *ngFor="let filter of view?.filters">
            <div>
              <span class="filter-column">{{ filter.columnUI }}</span>
              <span class="filter-operator">&nbsp;{{ filter.operatorUI }}&nbsp;</span>
              <ng-container *ngIf="filter.valueUI && filter.valueType !== 'date'">
                <q9-tag
                  [ngClass]="{'long-text': filter.valueUI.length > 50}"
                  [color]="'accent'"
                  [matTooltip]="filter.valueUI"
                  [matTooltipPosition]="'above'"
                  [matTooltipHideDelay]="300"
                  [matTooltipDisabled]="filter.valueUI.length < 50">
                  {{ filter.valueUI ? filter.valueUI : filter.value }}
                </q9-tag>
              </ng-container>
              <ng-container *ngIf="filter.valueType === 'query'">
                <q9-tag *ngFor="let item of filter.values" [color]="'accent'">
                  {{ item.parentName }}
                </q9-tag>
              </ng-container>
              <ng-container *ngIf="filter.valueType === 'tags'">
                <q9-tag *ngFor="let tag of filter.tags" [color]="'accent'">{{ tag }}</q9-tag>
              </ng-container>
              <ng-container *ngIf="filter.valueType === 'date'">
                <q9-tag [color]="'accent'">{{ filter.value | date: 'MMM d, y HH:mm' }}</q9-tag>
                <ng-container *ngIf="filter.secondValue">
                  <span class="filter-operator">and</span>
                  <q9-tag [color]="'accent'">
                    {{ filter.secondValue | date: 'MMM d, y HH:mm' }}
                  </q9-tag>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="filter.valueType === 'predefinedList'">
                <q9-tag *ngFor="let item of filter.listUI" [color]="'accent'">
                  {{ item.displayValue | translate }}
                </q9-tag>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="view.createdBy">
        <p class="detail-label">{{ 'RUBIC_CUBE.VIEW_CREATED_BY' | translate }}</p>
        <q9-user-info [user]="view.createdBy"></q9-user-info>
      </ng-container>
    </div>
  </ng-template>
</mat-menu>

<!-- System views list -->
<mat-menu #systemViews>
  <ng-container *ngFor="let systemView of cleanUpViewsList$ | async">
    <button mat-menu-item [title]="systemView.name" (click)="switchToCleanUpView(systemView)">
      {{ systemView.name | decodeHtml }}
    </button>
  </ng-container>
</mat-menu>
<!-- Private views list -->
<mat-menu #privateViews>
  <ng-container *ngFor="let privateView of privateCustomViewsList$ | async">
    <button
      class="truncate-text"
      mat-menu-item
      [title]="privateView.name"
      [matMenuTriggerFor]="actions"
      [matMenuTriggerData]="{view: privateView}"
      [ngClass]="{selected: privateView._id === selectedView?._id}">
      {{ privateView.name | decodeHtml }}
    </button>
  </ng-container>
</mat-menu>
